module.exports = require('./helpers/bundle-url').getBundleURL('1woTm') + "logo.c51670a8.svg";